<template>
  <div>
    <attachments
      :schema="$schema"
      :show-radio="false"
      :entity-type="EntityType.PROCEDURE"
      :entity-id="$route.params.procedureId.toString()"
      @errors="setErrors"
    />

    <template v-for="(error, index) in errors">
      <template v-for="(warning, warningIndex) in error.$warnings">
        <div :key="'error_' + index + '_' + warningIndex" class="py-2 text-warning">{{ warning }}</div>
      </template>
    </template>

    <div class="mt-4">
      <button class="btn btn-primary float-left" :disabled="!!errors.length" @click="previousStep">
        Wstecz
      </button>

      <button class="btn btn-primary float-right" :disabled="!!errors.length" @click="nextStep">
        Dalej
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import Attachments from '@/components/formComponents/attachment/Attachments';
import { EntityType } from '@/enums/entityType.enum';
import { wizardStepMixin } from '@/mixins/wizardStep';
import schema from '@/schemas/procedureAttachments.schema';

// @vuese
// Krok ze szczegółowymi danymi procedury
export default {
  components: { Attachments },
  mixins: [wizardStepMixin('procedure')],
  schema,
  data() {
    return { EntityType, errors: [] };
  },
  computed: mapState({
    stateData: state => ({ attachments: state.procedure.attachment.list })
  }),
  methods: {
    setErrors(val) {
      this.errors = [...val];
    }
  }
};
</script>
